import { render } from "./UseAsOwnerButton.vue?vue&type=template&id=08fdb5ba"
import script from "./UseAsOwnerButton.vue?vue&type=script&lang=js"
export * from "./UseAsOwnerButton.vue?vue&type=script&lang=js"
script.render = render

export default script